import { Toast } from 'primereact/toast';
import { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import AppBreadcrumb from '../../components/CustomeBreadcrumb/AppBreadcrumb';
import { GET_PASSOUT_DETAIL } from '../../config/ApiConstant';
import { getAllDetailsDirect } from '../../service/ProductService';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';

import { defaultRowOptions, defaultPageRowOptions, paginatorLinks, showingEntries, Skeletonitems, SkeletonbodyTemplate } from '../../appconfig/Settings';
import { passoutColumns } from '../../appconfig/DatatableSetting';

export const PassoutDetail = () => {
    document.title = 'Passout Detail | GSPC';

    const { id }: any = useParams();
    const toast = useRef<Toast>(null);

    const [pageLoad, setPageLoad] = useState<boolean>(false);
    const [passoutDetails, setPassoutDetails] = useState<any>(null);

    const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
    const [globalFilter, setGlobalFilter] = useState<string | null>(null);

    // useeffect
    useEffect(() => {
        if (id) {
            getPassoutDetailById(id);
        }
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    // api call get passout detail from id
    const getPassoutDetailById = async (passoutID: any) => {
        try {
            setPageLoad(true);
            const params: any = { type: 'Admin' };
            if (passoutID) params.id = atob(passoutID);

            const url = `${GET_PASSOUT_DETAIL}?${new URLSearchParams(params)}`;
            const response = await getAllDetailsDirect(url);

            if (response) setPassoutDetails(response);
        } catch (error: any) {
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        } finally {
            setPageLoad(false);
        }
    };

    // Template to open passout list file
    const fileTemplate = () =>
        !window.cn(passoutDetails?.passout_data?.passout_list) ? (
            <Button icon="pi pi-file" label="Download Passout List" className="flex ml-auto p-button-sm p-button-primary" onClick={() => window.open(passoutDetails.passout_data.passout_list, '_blank')} />
        ) : (
            'Not Available'
        );

    return (
        <>
            <Toast ref={toast} />
            <AppBreadcrumb currentMenu="Passout List" pageName="Passout List" pageTitle="Passout List" goToPage />

            {!pageLoad && passoutDetails && (
                <div className="grid crud-demo">
                    {/* ---- College / Degree Info ---- */}
                    <div className="col-12 mb-4">
                        <Card>
                            {/* Row 1: College + FileTemplate side by side */}
                            <div className="grid mb-3">
                                <div className="col-12 md:col-6">
                                    <p className="m-0">
                                        <strong>College:</strong> {!window.cn(passoutDetails?.passout_data?.college_name) ? passoutDetails?.passout_data?.college_name : '-'}
                                    </p>
                                </div>
                                <div className="col-12 md:col-6">{fileTemplate()}</div>
                            </div>

                            {/* Row 2: Remaining details */}
                            <div className="grid">
                                <div className="col-12 md:col-4">
                                    <p className="m-0">
                                        <strong>Degree:</strong> {!window.cn(passoutDetails?.passout_data?.degree_name) ? passoutDetails?.passout_data?.degree_name : '-'}
                                    </p>
                                </div>
                                <div className="col-12 md:col-4">
                                    <p className="m-0">
                                        <strong>From Year:</strong> {!window.cn(passoutDetails?.passout_data?.from_year) ? passoutDetails?.passout_data?.from_year : '-'}
                                    </p>
                                </div>
                                <div className="col-12 md:col-4">
                                    <p className="m-0">
                                        <strong>To Year:</strong> {!window.cn(passoutDetails?.passout_data?.to_year) ? passoutDetails?.passout_data?.to_year : '-'}
                                    </p>
                                </div>
                                <div className="col-12 md:col-4">
                                    <p className="m-0">
                                        <strong>Passout Status:</strong> {!window.cn(passoutDetails?.passout_data?.passout_status) ? passoutDetails?.passout_data?.passout_status : '-'}
                                    </p>
                                </div>
                            </div>
                        </Card>
                    </div>

                    {/* ---- Students List ---- */}
                    <div className="col-12">
                        <Card title="Passout Students">
                            {!pageLoad ? (
                                <DataTable
                                    value={passoutDetails?.data}
                                    showGridlines
                                    stripedRows
                                    globalFilter={globalFilter}
                                    filters={globalFieldFilter}
                                    onFilter={(e) => setGlobalFieldFilter(e.filters)}
                                    rows={defaultRowOptions}
                                    paginator={passoutDetails?.data.length >= 10}
                                    rowsPerPageOptions={defaultPageRowOptions}
                                    className="datatable-responsive p-datatable-sm"
                                    paginatorTemplate={paginatorLinks}
                                    currentPageReportTemplate={showingEntries}
                                    emptyMessage="No Passout students found"
                                    removableSort
                                >
                                    {passoutColumns.map((col) => {
                                        if (col.field === 'sr_no') {
                                            return <Column key={col.field} header={col.header} body={(_: any, { rowIndex }) => rowIndex + 1} />;
                                        } else if (['first_name', 'middle_name', 'last_name', 'enrollment_no', 'admitted_year'].includes(col.field)) {
                                            return <Column key={col.field} field={col.field} header={col.header} filter filterPlaceholder={`Search by ${col.header}`} sortable />;
                                        } else {
                                            return <Column key={col.field} field={col.field} header={col.header} sortable />;
                                        }
                                    })}
                                </DataTable>
                            ) : (
                                <DataTable value={Skeletonitems}>
                                    {passoutColumns.map((col) => (
                                        <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                                    ))}
                                </DataTable>
                            )}
                        </Card>
                    </div>
                </div>
            )}
        </>
    );
};
